import { arrayFieldModule } from '../array';
import { checkboxGroupFieldModule } from '../checkboxGroup';
import { conditionalFieldsGroupFieldModule } from '../conditionalFieldsGroup';
import { dateRangeFieldModule } from '../dateRange';
import { fieldsGroupFieldModule } from '../fieldsGroup';
import { fileFieldModule } from '../file';
import { loginFieldModule } from '../login';
import { officeHoursFieldModule } from '../officeHours';
import { questionWithDetailsFieldModule } from '../questionWithDetails';
import { radioGridFieldModule } from '../radioGrid';
import { singleFieldModule } from '../single';
import { stagedFieldsGroupFieldModule } from '../stagedFieldsGroup';

import { fieldModuleRegistry } from './field-module.registry';

function initializeFieldModuleRegistry() {
  fieldModuleRegistry
    .register(arrayFieldModule.type, arrayFieldModule)
    .register(checkboxGroupFieldModule.type, checkboxGroupFieldModule)
    .register(conditionalFieldsGroupFieldModule.type, conditionalFieldsGroupFieldModule)
    .register(dateRangeFieldModule.type, dateRangeFieldModule)
    .register(fieldsGroupFieldModule.type, fieldsGroupFieldModule)
    .register(fileFieldModule.type, fileFieldModule)
    .register(loginFieldModule.type, loginFieldModule)
    .register(officeHoursFieldModule.type, officeHoursFieldModule)
    .register(questionWithDetailsFieldModule.type, questionWithDetailsFieldModule)
    .register(radioGridFieldModule.type, radioGridFieldModule)
    .register(stagedFieldsGroupFieldModule.type, stagedFieldsGroupFieldModule)
    .setFallbackModule(singleFieldModule);
}

initializeFieldModuleRegistry();
